import { THEMES } from 'src/constants';
import { softShadows } from '../shadows';

export default {
  name: THEMES.AQUA,
  light: {
    palette: {
      type: 'light',
      background: {
        default: '#FAFAFA',
        paper: '#FFFFFF',
        navbar: '#1D9BF0',
        dark: '#f4f6f8'
      },
      primary: {
        main: '#1D9BF0',
        contrastText: 'rgba(255,255,255,0.87)'
      },
      secondary: {
        main: '#1D9BF0',
        contrastText: 'rgba(255,255,255,0.87)'
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.87)',
        secondary: 'rgba(0, 0, 0, 0.6)',
        disabled: 'rgba(0, 0, 0, 0.38)'
      }
    },
    shadows: softShadows
  },
  dark: {
    palette: {
      type: 'dark',
      background: {
        default: '#303030',
        navbar: '#1D9BF0',
        paper: '#424242',
        dark: '#303030'
      },
      primary: {
        main: '#1D9BF0',
        contrastText: 'rgba(255,255,255,0.87)'
      },
      secondary: {
        main: '#1D9BF0',
        contrastText: 'rgba(255,255,255,0.87)'
      },
      text: {
        primary: '#FFFFFF',
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)'
      }
    },
    shadows: softShadows
  }
};
